import React, { useEffect, useState } from "react";
import _ from "lodash";

import { connect } from "react-redux";
import { withSocket } from "../../socket/context";
import { compose } from "redux";
import { removeUser } from "../shared/utils";

import { selected_img } from "../../assets/images/fluster";
import { lobby_circle } from "../../assets/images/fluster";
import { user_cross } from "../../assets/images/fluster";

const FlusterUsers = (props) => {
  const users = _.get(props, "gameReducer.roomObj.users");

  const delPlayer = (data) => {
    const roomObj = props.gameReducer.roomObj;
    removeUser(roomObj, data);
  };
  const [allUsers, setAllUsers] = useState([]);

  const comparer = (otherArray) => {
    return function (current) {
      return (
        otherArray?.filter(function (other) {
          return other?.player_id === current?.player_id;
        }).length === 0
      );
    };
  };

  useEffect(() => {
    let { gameReducer } = props;
    let roomObj = _.get(gameReducer, "roomObj");
    if (
      // usersChanged &&
      Object.keys(roomObj).length > 0 &&
      roomObj.users.length > 0
    ) {
      if (roomObj.users.length > allUsers.length) {
        let result = roomObj.users.filter(comparer(allUsers));
        playAudio(
          result && result[0].audio_effect ? result[0].audio_effect : ""
        );
        setAllUsers(roomObj.users);
      }
    }
    if (
      Object.keys(roomObj).length > 0 &&
      roomObj.users.length < allUsers.length
    ) {
      setAllUsers(roomObj.users);
    }
  }, [props.gameReducer.roomObj]);

  const playAudio = (url) => {
    var audio = document.createElement("audio");
    audio.src = url;
    audio.style.display = "none"; //added to fix ios issue
    audio.autoplay = true; //avoid the user has not interacted with your page issue
    audio.onended = function () {
      audio.remove(); //remove after playing to clean the Dom
    };
    document.body.appendChild(audio);
  };

  return (
    <div className="users">
      <h4 className="player-name mb-3">Players</h4>
      <div className="user-section">
        {users &&
          users.length > 0 &&
          users.map((user) => (
            <>
              <div className="d-flex flex-column align-items-center" style={{marginRight: '6px'}}>
                <div className="user-image-container">
                  <img src={lobby_circle} alt="" className="user-border" />

                  <img src={user.profile_image} alt="" className="user-image" />
                  <div className="cross" onClick={() => delPlayer(user)}>
                    <img src={user_cross} alt="" className="user_cross" />
                  </div>
                </div>
                <p className="text-light mt-2" style={{marginRight: '16px'}}>{user.display_name}</p>
              </div>
            </>
          ))}
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});

export default compose(
  withSocket,
  connect(mapStateToProps, null)
)(FlusterUsers);
